import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class AppLocalizedPaginator implements MatPaginatorIntl {
	changes = new Subject<void>();

	// For internationalization, the `$localize` function from
	// the `@angular/localize` package can be used.
	firstPageLabel = $localize`:@@i18nPaginator-firstPage:First page`;
	itemsPerPageLabel = $localize`:@@i18nPaginator-itemsPerPage:Items per page`;
	lastPageLabel = $localize`:@@i18nPaginator-lastPage:Last page`;

	// You can set labels to an arbitrary string too, or dynamically compute
	// it through other third-party internationalization libraries.
	nextPageLabel = $localize`:@@i18nPaginator-nextPage:Next page`;
	previousPageLabel = $localize`:@@i18nPaginator-previousPage:Previous page`;

	getRangeLabel(page: number, pageSize: number, length: number): string {
		if (length === 0) {
			return $localize`:@@i18nPaginator-pageOneOfOne:Page 1 of 1`;
		}
		const amountPages = Math.ceil(length / pageSize);
		return $localize`:@@i18nPaginator-pageXOfMany:Page ${page + 1} of ${amountPages}`;
	}
}
